import { format } from '@formkit/tempo'

const DEFAULT_SELECTORS = {
	formInfo: '.js-form-info',
	checkIn: '.js-form-info-checkin',
	checkOut: '.js-form-info-checkout',
	guests: '.js-form-info-guests',
	guestsLabel: '.js-form-info-guests-label', // У елемента повинно бути 2 дата атрибута: singular і plural
}

const LOCALE = shared.options.language.code || 'en'

const STORE_FORMATTERS = {
	checkIn: date => format(date, 'MMM D', LOCALE),
	checkOut: date => format(date, 'MMM D', LOCALE),
	guests: (adults, children) => adults + children,
}

export const updateFormInfoView = storeData => {
	const formInfoElement = document.querySelector(DEFAULT_SELECTORS.formInfo)

	if (!formInfoElement) return

	const checkInElement = formInfoElement.querySelector(DEFAULT_SELECTORS.checkIn)
	const checkOutElement = formInfoElement.querySelector(DEFAULT_SELECTORS.checkOut)
	const guestsElement = formInfoElement.querySelector(DEFAULT_SELECTORS.guests)
	const guestsLabelElement = formInfoElement.querySelector(
		DEFAULT_SELECTORS.guestsLabel
	)

	if (checkInElement)
		checkInElement.textContent = STORE_FORMATTERS.checkIn(storeData.checkIn)

	if (checkOutElement)
		checkOutElement.textContent = STORE_FORMATTERS.checkOut(storeData.checkOut)

	const totalGuests = STORE_FORMATTERS.guests(
		storeData.adultsCount,
		storeData.childrenCount
	)

	if (guestsElement) guestsElement.textContent = totalGuests

	if (guestsLabelElement) {
		const { singular, plural } = guestsLabelElement.dataset
		if (!singular || !plural) return

		guestsLabelElement.textContent = totalGuests > 1 ? plural : singular
	}
}
